import datasetParser from "@Dataset/datasetParser";
import IconRating from "@Icons/IconRating";
import {Colors} from "@Styles/Colors.style";
import Translation from "@Translation/components/Translation";
import React from "react";

interface StsCompanyRatingProps {
    index?: number,
}

export const StsCompanyRating = ({index}: StsCompanyRatingProps) => {
    const companyData = datasetParser({className: 'company-rating__score', index});

    return (
        companyData?.score > 0 && (
            <>
                <IconRating fill={Colors.warningColor} stroke={Colors.warningColor}/>
                {companyData?.score}
            </>
        )
    )
}